// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"e11c2e6a","5744":"ba53be2f","6100":"ba53be2f","6225":"b5b4bc2f","6776":"ba53be2f","7164":"ba53be2f","9545":"ba53be2f"}[chunkId] + ".chunk.css";
};